/**
 * Valkyrie Exact Cart Drawer Controller
 * 1-on-1 Replicatie van Valkyrie Organics Cart Drawer
 */

(function() {
  'use strict';

  // DOM Elements
  let wrapper, backdrop, drawer, closeBtn, itemsContainer, subtotalEl, countEl;
  let guideSwitch, crossSellBtn, trainersBtn, discountRow, discountValEl, discountLabelEl;

  // State
  const BINNENBAL_VARIANT_ID = '55719012368723'; // Default Large Reserve Binnenbal (€14,95)
  const BINNENBAL_SIZE_MAP = {
    'Small': '55605870264659',
    'Medium': '55719012335955',
    'Large': '55719012368723'
  };
  const ALL_BINNENBAL_IDS = ['55605870264659', '55719012335955', '55719012368723'];
  let userChangedBinnenbalSize = false;
  const TRAINERS_VARIANT_ID = '55605870625107'; // Live Drevit® Kynologische Trainers Rundvlees (€12,95)

  function formatMoney(cents) {
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  function isPhysicalBall(item) {
    if (!item) return false;
    const t = (item.product_title || item.title || '').toLowerCase();
    const vId = String(item.id || item.variant_id || '');
    if (vId === '54929139564883' || t.includes('trainingsgids') || t.includes('e-book') || t.includes('gids')) {
      return false;
    }
    return t.includes('drijfbal') || t.includes('valkyrie') || t.includes('herding');
  }

  function init() {
    wrapper = document.getElementById('vk-cart-drawer-wrapper');
    if (!wrapper) return;

    backdrop = document.getElementById('vk-cart-backdrop');
    drawer = document.getElementById('vk-cart-drawer');
    closeBtn = document.getElementById('vk-cart-close');
    itemsContainer = document.getElementById('vk-cart-items-container');
    subtotalEl = document.getElementById('vk-cart-subtotal');
    countEl = document.getElementById('vk-cart-count');
    guideSwitch = document.getElementById('vk-guide-switch');
    crossSellBtn = document.getElementById('vk-add-cross-sell-btn');
    trainersBtn = document.getElementById('vk-add-trainers-btn');
    discountRow = document.getElementById('vk-cart-discount-row');
    discountValEl = document.getElementById('vk-discount-val');
    discountLabelEl = document.getElementById('vk-discount-label');

    // Event Listeners for Open/Close
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (backdrop) backdrop.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && wrapper.classList.contains('active')) {
        closeCartDrawer();
      }
    });

    // Intercept Header / Navigation Cart Icon Clicks
    document.querySelectorAll('a[href="/cart"], .header__icon--cart, [data-cart-trigger], [data-cart-drawer-trigger]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    });

    // Update initial header cart bubble
    fetch('/cart.js')
      .then(res => res.json())
      .then(c => {
        const cnt = c.item_count || 0;
        document.querySelectorAll('.vk-header-cart-count').forEach(el => {
          el.textContent = cnt;
          el.style.display = cnt > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});

    // Upsell 1: Reserve Binnenbal & Snelsluiting Kit (3 Maten: Small, Medium, Large)
    const binnenbalSelect = document.getElementById('vk-binnenbal-size-select');
    if (binnenbalSelect) {
      binnenbalSelect.addEventListener('change', () => {
        userChangedBinnenbalSize = true;
        if (crossSellBtn) {
          crossSellBtn.setAttribute('data-variant-id', binnenbalSelect.value);
          if ( lastCartData && lastCartData.items ) {
            const alreadyIn = lastCartData.items.some(i => String(i.id) === String(binnenbalSelect.value) || String(i.variant_id) === String(binnenbalSelect.value));
            crossSellBtn.textContent = alreadyIn ? 'Toegevoegd ✓' : '+ Toevoegen';
            crossSellBtn.disabled = alreadyIn;
            crossSellBtn.classList.toggle('added', alreadyIn);
          }
        }
      });
    }
    if (crossSellBtn) {
      crossSellBtn.addEventListener('click', () => {
        const sizeSelectEl = document.getElementById('vk-binnenbal-size-select');
        const chosenVarId = (sizeSelectEl && sizeSelectEl.value) ? sizeSelectEl.value : BINNENBAL_VARIANT_ID;
        crossSellBtn.disabled = true;
        crossSellBtn.textContent = 'Toevoegen...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: chosenVarId, quantity: 1 }] })
        })
        .then(res => res.json())
        .then(() => {
          crossSellBtn.textContent = 'Toegevoegd! ✓';
          crossSellBtn.classList.add('added');
          renderCart();
        })
        .catch(err => {
          console.error('Error adding binnenbal:', err);
          crossSellBtn.disabled = false;
          crossSellBtn.textContent = '+ Toevoegen';
        });
      });
    }

    // Upsell 2: Kynologische Trainers Rundvlees
    if (trainersBtn) {
      trainersBtn.addEventListener('click', () => {
        trainersBtn.disabled = true;
        trainersBtn.textContent = 'Toevoegen...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: TRAINERS_VARIANT_ID, quantity: 1 }] })
        })
        .then(res => res.json())
        .then(() => {
          trainersBtn.textContent = 'Toegevoegd! ✓';
          trainersBtn.classList.add('added');
          renderCart();
        })
        .catch(err => {
          console.error('Error adding trainers:', err);
          trainersBtn.disabled = false;
          trainersBtn.textContent = '+ Toevoegen';
        });
      });
    }

    // Guide upsell toggle switch (€4,95)
    if (guideSwitch) {
      guideSwitch.addEventListener('change', () => {
        const variantId = guideSwitch.getAttribute('data-variant-id') || '54929139564883';
        const isAdding = guideSwitch.checked;
        guideSwitch.disabled = true;

        if (isAdding) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_is_guide_upsell': 'true' } }] })
          })
          .then(res => res.json())
          .then(() => {
            guideSwitch.disabled = false;
            renderCart();
          })
          .catch(err => {
            console.error('Error adding guide upsell:', err);
            guideSwitch.checked = false;
            guideSwitch.disabled = false;
          });
        } else {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const item = cart.items.find(i => String(i.id) === String(variantId) || String(i.variant_id) === String(variantId) || (i.title && i.title.toLowerCase().includes('trainingsgids')));
              if (item) {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: 0 })
                });
              }
            })
            .then(() => {
              guideSwitch.disabled = false;
              renderCart();
            })
            .catch(err => {
              console.error('Error removing guide upsell:', err);
              guideSwitch.checked = true;
              guideSwitch.disabled = false;
            });
        }
      });
    }
  }

  function openCartDrawer() {
    if (!wrapper) wrapper = document.getElementById('vk-cart-drawer-wrapper');
    if (!wrapper) return;

    wrapper.classList.add('active');
    wrapper.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    document.body.style.overflow = 'hidden';

    renderCart();
  }

  function closeCartDrawer() {
    if (!wrapper) return;
    wrapper.classList.remove('active');
    wrapper.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.overflow = '';
  }

  let lastCartData = null;

  function renderCart() {
    if (!itemsContainer) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        lastCartData = cart;

        // Total count
        const count = cart.item_count || 0;
        if (countEl) countEl.textContent = count;
        document.querySelectorAll('.vk-header-cart-count').forEach(el => {
          el.textContent = count;
          el.style.display = count > 0 ? 'flex' : 'none';
        });

        const giftsSection = document.getElementById('vk-cart-gifts-section');
        const emptyState = itemsContainer.querySelector('.vk-cart-empty-state');

        if (cart.items.length === 0) {
          itemsContainer.innerHTML = `
            <div class="vk-cart-empty-state">
              <div style="font-size: 40px; margin-bottom: 8px;">🐶</div>
              <p style="font-size: 15px; font-weight: 600; color: #1e293b;">Je winkelwagen is leeg.</p>
              <p style="font-size: 13px; color: #64748b; margin-top: 4px;">Kies een voordeelbundel om te profiteren van de actie!</p>
              <a href="/products/valkyrie-herding-ball" class="vk-continue-btn" style="margin-top: 14px;">Bekijk de Drevit Drijfbal</a>
            </div>
          `;
          if (giftsSection) giftsSection.style.display = 'none';
          if (subtotalEl) subtotalEl.textContent = '€0,00';
          if (discountRow) discountRow.style.display = 'none';
          return;
        }

        if (giftsSection) giftsSection.style.display = 'block';

        // 0. Cart Integrity Check (Prevent Stacking & Auto-Purge gifts if ball is removed)
        const FREE_GIFT_IDS = ['54882144223571', '54882160378195', '54902781509971', '54902767223123'];
        
        let totalBallQty = 0;
        let detectedBallSize = null;
        cart.items.forEach(i => {
          if (isPhysicalBall(i)) {
            const fullTitle = ((i.title || '') + ' ' + (i.variant_title || '')).toLowerCase();
            const propAanbieding = (i.properties && (i.properties['_aanbieding'] || i.properties['_bundel'] || '')).toLowerCase();
            const isTwoBallVariant = fullTitle.includes('2x') || fullTitle.includes('duo') || propAanbieding.includes('bogo') || propAanbieding.includes('2x');
            totalBallQty += isTwoBallVariant ? (i.quantity * 2) : i.quantity;

            if (!detectedBallSize) {
              if (fullTitle.includes('small') || (i.properties && (i.properties['Maat'] === 'Small' || i.properties['Bal #1 (Hoofdbal)'] === 'Small'))) {
                detectedBallSize = 'Small';
              } else if (fullTitle.includes('medium') || (i.properties && (i.properties['Maat'] === 'Medium' || i.properties['Bal #1 (Hoofdbal)'] === 'Medium'))) {
                detectedBallSize = 'Medium';
              } else if (fullTitle.includes('large') || (i.properties && (i.properties['Maat'] === 'Large' || i.properties['Bal #1 (Hoofdbal)'] === 'Large'))) {
                detectedBallSize = 'Large';
              }
            }
          }
        });

        // Auto-match Reserve Binnenbal dropdown to customer's ball size if not manually overridden
        const binnenbalSelectEl = document.getElementById('vk-binnenbal-size-select');
        if (binnenbalSelectEl && detectedBallSize && !userChangedBinnenbalSize && BINNENBAL_SIZE_MAP[detectedBallSize]) {
          binnenbalSelectEl.value = BINNENBAL_SIZE_MAP[detectedBallSize];
        }

        const integrityUpdates = {};
        let needsIntegrityFix = false;

        cart.items.forEach(item => {
          const isGift = FREE_GIFT_IDS.includes(String(item.id)) || 
                         FREE_GIFT_IDS.includes(String(item.variant_id)) || 
                         (item.properties && (item.properties['_is_free_gift'] === 'true' || item.properties['_free_gift'] === 'true'));
          
          if (isGift) {
            // If ball is removed, remove all free gifts instantly
            if (totalBallQty === 0) {
              integrityUpdates[item.key] = 0;
              needsIntegrityFix = true;
            } else if (item.quantity > 1) {
              // Prevent duplicate gift stacking
              integrityUpdates[item.key] = 1;
              needsIntegrityFix = true;
            } else if (totalBallQty === 1) {
              // Single ball only gets gift 1 & 2 (Voetpomp & Breinspeeltje); remove gifts 3 & 4
              const vId = String(item.id || item.variant_id);
              const t = (item.title || item.product_title || '').toLowerCase();
              if (vId === '54902781509971' || vId === '54902767223123' || t.includes('ijsjes') || t.includes('waardebon') || t.includes('cadeaubon')) {
                integrityUpdates[item.key] = 0;
                needsIntegrityFix = true;
              }
            }
          }
        });

        if (needsIntegrityFix) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: integrityUpdates })
          })
          .then(res => res.json())
          .then(updatedCart => {
            renderCart();
          })
          .catch(() => {});
          return;
        }

        // Render line items (Main products first, free gifts at bottom)
        let itemsHTML = '';
        let hasBundleDiscount = false;

        function getGiftDetails(item) {
          const t = (item.title || item.product_title || '').toLowerCase();
          const vId = String(item.id || item.variant_id);
          if (vId === '54882144223571' || t.includes('voetpomp') || t.includes('pomp')) {
            return { name: 'Handige Voetpomp', origPrice: '€11,95' };
          }
          if (vId === '54882160378195' || t.includes('speeltje')) {
            return { name: 'Interactief Breinspeeltje', origPrice: '€15,95' };
          }
          if (vId === '54902781509971' || t.includes('ijsjes')) {
            return { name: 'IJsjes Gids', origPrice: '€23,95' };
          }
          if (vId === '54902767223123' || t.includes('waardebon') || t.includes('cadeaubon')) {
            return { name: '€20 Cadeaubon', origPrice: '€20,00' };
          }
          return null;
        }

        const sortedItems = [...cart.items].sort((a, b) => {
          const aIsFree = (a.price === 0) || (a.properties && (a.properties['_free_gift'] === 'true' || a.properties['_is_free_gift'] === 'true'));
          const bIsFree = (b.price === 0) || (b.properties && (b.properties['_free_gift'] === 'true' || b.properties['_is_free_gift'] === 'true'));
          if (aIsFree && !bIsFree) return 1;
          if (!aIsFree && bIsFree) return -1;

          const aTitle = (a.product_title || a.title || '').toLowerCase();
          const bTitle = (b.product_title || b.title || '').toLowerCase();
          const aIsBall = aTitle.includes('drijfbal') || aTitle.includes('valkyrie') || aTitle.includes('herding');
          const bIsBall = bTitle.includes('drijfbal') || bTitle.includes('valkyrie') || bTitle.includes('herding');
          if (aIsBall && !bIsBall) return -1;
          if (!aIsBall && bIsBall) return 1;

          return 0;
        });

        sortedItems.forEach((item, index) => {
          // If this is the training guide upsell, don't duplicate it in the top item list (it is controlled via the dedicated toggle row above subtotal)
          const isGuide = String(item.id) === '54929139564883' || String(item.variant_id) === '54929139564883' || (item.title && item.title.toLowerCase().includes('trainingsgids'));
          if (isGuide) return;

          const isBall = item.title.toLowerCase().includes('drijfbal') || item.title.toLowerCase().includes('valkyrie');
          const giftDetails = getGiftDetails(item);
          const isFreeGift = (item.price === 0) || (item.properties && (item.properties['_free_gift'] === 'true' || item.properties['_is_free_gift'] === 'true')) || (giftDetails !== null);
          // Do not duplicate free gifts as bulky product cards in #vk-cart-items-container; they are displayed cleanly in #vk-cart-gifts-section right below!
          if (isFreeGift) return;

          const itemPrice = item.price; // in cents
          const origCompare = isBall ? Math.round(itemPrice * 1.35) : itemPrice;
          const lineTotal = itemPrice * item.quantity;
          const lineSavings = (origCompare - itemPrice) * item.quantity;

          let badgeHTML = '';
          if (isFreeGift) {
            badgeHTML = `<div class="vk-cart-item-bundle-badge" style="background:#ecfdf5;color:#059669;border-color:#a7f3d0;">🎁 Inbegrepen Zomeractie Cadeau</div>`;
          } else if (item.properties && item.properties['_bundel']) {
            hasBundleDiscount = true;
            badgeHTML = `<div class="vk-cart-item-bundle-badge">🏷️ ${item.properties['_bundel']}</div>`;
          } else if (item.quantity >= 2 && isBall) {
            hasBundleDiscount = true;
            badgeHTML = `<div class="vk-cart-item-bundle-badge">🏷️ Koop 2 - Blije Honden Bundel</div>`;
          }

          let giftsNoteHTML = '';
          if (!isFreeGift && item.properties && item.properties['Inbegrepen Cadeaus']) {
            giftsNoteHTML = `<div class="vk-cart-item-gift-note" style="font-size: 11px; color: #059669; font-weight: 600; margin-top: 2px;">🎁 ${item.properties['Inbegrepen Cadeaus']}</div>`;
          }

          let variantLabel = item.variant_title;
          if (variantLabel && variantLabel.toLowerCase() !== 'default title') {
            variantLabel = isFreeGift ? variantLabel : `Maat: ${variantLabel}`;
          } else {
            variantLabel = '';
          }

          const itemImg = item.image || (item.featured_image && (item.featured_image.url || item.featured_image)) || '//drevit-dieren.be/cdn/shop/t/1/assets/bundle-ball-1.png';

          const stepperHTML = isFreeGift
            ? `<div style="display:flex;align-items:center;padding:4px 8px;background:#f1f5f9;border-radius:6px;"><span style="font-size:12px;color:#475569;font-weight:600;">Aantal: 1 (Gratis)</span></div>`
            : `<div class="vk-qty-stepper">
                <button type="button" class="vk-qty-btn vk-qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                <span class="vk-qty-val">${item.quantity}</span>
                <button type="button" class="vk-qty-btn vk-qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>`;

          let priceHTML = '';
          if (isFreeGift && giftDetails) {
            priceHTML = `
              <div class="vk-cart-item-prices">
                <span class="vk-cart-item-orig-price" style="text-decoration: line-through; color: #94a3b8; font-size: 13px; margin-right: 6px;">${giftDetails.origPrice}</span>
                <span class="vk-cart-item-final-price" style="color: #059669; font-weight: 700; font-size: 14px;">GRATIS</span>
              </div>
              <div class="vk-item-save-note" style="color: #059669; font-size: 11px; font-weight: 600; margin-top: 1px;">(Je bespaart ${giftDetails.origPrice})</div>
            `;
          } else if (isFreeGift) {
            priceHTML = `
              <div class="vk-cart-item-prices">
                <span class="vk-cart-item-final-price" style="color: #059669; font-weight: 700; font-size: 14px;">GRATIS</span>
              </div>
            `;
          } else {
            priceHTML = `
              <div class="vk-cart-item-prices">
                ${origCompare > itemPrice ? `<span class="vk-cart-item-orig-price">${formatMoney(origCompare * item.quantity)}</span>` : ''}
                <span class="vk-cart-item-final-price">${formatMoney(lineTotal)}</span>
              </div>
              ${lineSavings > 0 ? `<div class="vk-item-save-note">(Je bespaart ${formatMoney(lineSavings)})</div>` : ''}
            `;
          }

          itemsHTML += `
            <div class="vk-cart-item" data-key="${item.key}">
              <div class="vk-cart-item-thumb">
                <img src="${itemImg}" alt="${item.title}" />
              </div>
              <div class="vk-cart-item-details">
                <div class="vk-cart-item-top">
                  <div class="vk-cart-item-title">${item.product_title || item.title}</div>
                  <button type="button" class="vk-cart-item-delete" data-key="${item.key}" aria-label="Verwijder artikel">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
                
                ${badgeHTML}
                ${giftsNoteHTML}

                ${variantLabel ? `<div class="vk-cart-item-variant-label">${variantLabel}</div>` : ''}

                <div class="vk-cart-item-bottom">
                  ${stepperHTML}
                  <div class="vk-item-total-col">
                    ${priceHTML}
                  </div>
                </div>
              </div>
            </div>
          `;
        });

        itemsContainer.innerHTML = itemsHTML;

        // Bind Stepper and Delete Buttons
        itemsContainer.querySelectorAll('.vk-qty-btn, .vk-cart-item-delete').forEach(btn => {
          btn.addEventListener('click', (e) => {
            const key = btn.getAttribute('data-key');
            let newQty = 0;
            if (btn.classList.contains('vk-qty-plus') || btn.classList.contains('vk-qty-minus')) {
              newQty = parseInt(btn.getAttribute('data-qty'), 10);
            }
            updateItemQuantity(key, newQty);
          });
        });

        // Discount banner update
        if (discountRow) {
          if (totalBallQty >= 2) {
            discountRow.style.display = 'flex';
            if (discountValEl) discountValEl.textContent = '-€17,68';
            if (discountLabelEl) discountLabelEl.textContent = 'Koop 2 - Blije Honden Bundel';
          } else if (totalBallQty === 1) {
            discountRow.style.display = 'flex';
            if (discountValEl) discountValEl.textContent = '-€25,05';
            if (discountLabelEl) discountLabelEl.textContent = '1x Kopen (30% Korting)';
          } else {
            discountRow.style.display = 'none';
          }
        }

        // Update #vk-cart-gifts-section visual state for 1 ball vs 2+ balls
        const giftPills = document.querySelectorAll('#vk-cart-gifts-section .vk-gift-pill');
        const giftsBadgeEl = document.querySelector('#vk-cart-gifts-section .vk-gifts-badge');
        if (giftPills.length >= 4) {
          if (totalBallQty >= 2) {
            giftPills[2].style.opacity = '1';
            giftPills[2].style.filter = 'none';
            giftPills[3].style.opacity = '1';
            giftPills[3].style.filter = 'none';
            if (giftsBadgeEl) giftsBadgeEl.textContent = 'ALLE 4 ONTGRENDELD';
          } else {
            giftPills[2].style.opacity = '0.45';
            giftPills[2].style.filter = 'grayscale(70%)';
            giftPills[3].style.opacity = '0.45';
            giftPills[3].style.filter = 'grayscale(70%)';
            if (giftsBadgeEl) giftsBadgeEl.textContent = '2 VAN 4 ONTGRENDELD (4 BIJ 2+ BALLEN)';
          }
        }

        // Cross-sell button 1 (Binnenbal 3 sizes) state update
        if (crossSellBtn) {
          const activeSizeVarId = (binnenbalSelectEl && binnenbalSelectEl.value) ? String(binnenbalSelectEl.value) : String(BINNENBAL_VARIANT_ID);
          const crossSellInCart = cart.items.some(i => ALL_BINNENBAL_IDS.includes(String(i.id)) || ALL_BINNENBAL_IDS.includes(String(i.variant_id)));
          if (crossSellInCart && (!userChangedBinnenbalSize || cart.items.some(i => String(i.id) === activeSizeVarId || String(i.variant_id) === activeSizeVarId))) {
            crossSellBtn.textContent = 'Toegevoegd ✓';
            crossSellBtn.classList.add('added');
            crossSellBtn.disabled = true;
          } else {
            crossSellBtn.textContent = '+ Toevoegen';
            crossSellBtn.classList.remove('added');
            crossSellBtn.disabled = false;
          }
        }

        // Cross-sell button 2 (Trainers) state update
        if (trainersBtn) {
          const trainersInCart = cart.items.some(i => String(i.id) === String(TRAINERS_VARIANT_ID) || String(i.variant_id) === String(TRAINERS_VARIANT_ID));
          if (trainersInCart) {
            trainersBtn.textContent = 'Toegevoegd ✓';
            trainersBtn.classList.add('added');
            trainersBtn.disabled = true;
          } else {
            trainersBtn.textContent = '+ Toevoegen';
            trainersBtn.classList.remove('added');
            trainersBtn.disabled = false;
          }
        }

        // Guide upsell switch state update
        if (guideSwitch) {
          const guideVariantId = guideSwitch.getAttribute('data-variant-id') || '54929139564883';
          const guideInCart = cart.items.some(i => String(i.id) === String(guideVariantId) || String(i.variant_id) === String(guideVariantId) || (i.title && i.title.toLowerCase().includes('trainingsgids')));
          guideSwitch.checked = guideInCart;
          guideSwitch.disabled = false;
        }

        updateSubtotalDisplay();
      })
      .catch(err => {
        console.error('Error fetching cart:', err);
      });
  }

  function updateSubtotalDisplay() {
    if (!lastCartData || !subtotalEl) return;
    const subtotalCents = lastCartData.total_price || 0;
    subtotalEl.textContent = formatMoney(subtotalCents);
  }

  function updateItemQuantity(key, qty) {
    // If setting a ball quantity to 0, check if this leaves 0 balls in cart
    if (qty === 0 && lastCartData) {
      const deletingItem = lastCartData.items.find(i => i.key === key);
      const isBall = isPhysicalBall(deletingItem);
      
      if (isBall) {
        const remainingBalls = lastCartData.items.filter(i => i.key !== key && isPhysicalBall(i));
        if (remainingBalls.length === 0) {
          // All balls removed! Wipe all free gifts in the exact same update call
          const FREE_GIFT_IDS = ['54882144223571', '54882160378195', '54902781509971', '54902767223123'];
          const updates = { [key]: 0 };
          lastCartData.items.forEach(i => {
            const isGift = FREE_GIFT_IDS.includes(String(i.id)) || 
                           FREE_GIFT_IDS.includes(String(i.variant_id)) || 
                           (i.properties && (i.properties['_is_free_gift'] === 'true' || i.properties['_free_gift'] === 'true'));
            if (isGift) updates[i.key] = 0;
          });

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          })
          .then(res => res.json())
          .then(cart => renderCart())
          .catch(err => console.error('Error wiping cart:', err));
          return;
        }
      }
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(res => res.json())
    .then(cart => {
      renderCart();
    })
    .catch(err => {
      console.error('Error updating cart quantity:', err);
    });
  }

  // Global exposure
  window.openValkyrieCartDrawer = openCartDrawer;
  window.openCartDrawer = openCartDrawer;
  window.closeValkyrieCartDrawer = closeCartDrawer;
  window.refreshValkyrieCart = renderCart;

  // Listen to custom event
  document.addEventListener('open-valkyrie-cart', openCartDrawer);
  document.addEventListener('cart:item-added', openCartDrawer);
  document.addEventListener('cart:refresh', renderCart);

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
